export default __webpack_public_path__ + "static/media/Measuring-tape-black.b25f04f5.svg";